module.exports = __webpack_public_path__ + "img/tv.tv3ba10c5.svg";